// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReferralHistory-module-referralHistory-3l8d4{border:1px solid rgba(151,151,151,.33);border-radius:8px;padding:24px;margin-top:24px}@media(min-width: 768px){.ReferralHistory-module-referralHistory-3l8d4{padding-block:32px 40px;padding-inline:32px}}.ReferralHistory-module-referralHistory-3l8d4 .ReferralHistory-module-title-1TFMf{height:46px}@media(min-width: 768px){.ReferralHistory-module-referralHistory-3l8d4 .ReferralHistory-module-title-1TFMf{height:74px}}.ReferralHistory-module-linkWrapper-Ruw4G{justify-content:flex-end;width:100%;display:flex;margin-top:18px}", ""]);
// Exports
exports.locals = {
	"referralHistory": "ReferralHistory-module-referralHistory-3l8d4",
	"title": "ReferralHistory-module-title-1TFMf",
	"linkWrapper": "ReferralHistory-module-linkWrapper-Ruw4G"
};
module.exports = exports;
